const DeleteTeam = ({ isOpen, onClose, title, description, ref, setShowDeleteTeamPopup, setShowNotification, setNotificationMessage, handleDelete, isSaveLoading }) => {

    if (!isOpen) return null;
    return (
        <div className="popup-overlay" >
            <div className="popup-box" ref={ref}>
                <div className='popup-top-content'>
                    <div className="popup-close" onClick={onClose}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13 1L1 13M1 1L13 13" stroke="#05171A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className='popup-content'>
                        <div className='popup-title'>{title}</div>
                        <p className="description">
                            {description}
                        </p>
                        <p className="warning">
                            This action is irreversible, so please confirm if you’re sure.
                        </p>
                    </div>
                </div>
                <div className="button-row">
                    <button className="cancel-btn" onClick={onClose}>Cancel</button>
                    <button
                        className={`suspend-btn delete-btn button ${isSaveLoading ? 'btn_loading' : ''
                            }`}
                        onClick={() => { handleDelete(); }}
                    >
                        {isSaveLoading ? (
                            <div className="registerLoader">
                                <div className="ring-loader"></div>
                            </div>
                        ) : (
                            'Delete'
                        )}
                    </button>
                </div>
            </div>
        </div >
    )
}

export default DeleteTeam